import * as apiGetEodReport from "@/api/vp/eodReports/getEodReport";
import * as apiGetEodReports from "@/api/vp/eodReports/getEodReports";
import * as apiAddEodReport from "@/api/vp/eodReports/addEodReport";
import * as apiUpdateEodReport from "@/api/vp/eodReports/updateEodReport";
import * as apiDeleteEodReport from "@/api/vp/eodReports/deleteEodReport";
import * as apiSendEodReport from "@/api/vp/eodReports/sendEodReport";

import _ from "lodash";

export default {
    namespaced: true,
    state: {
        loading: false,
        eodReports: [],
        eodReport: null,
    },
    mutations: {
        gotEodReport(state, result) {
            state.eodReport = result;
        },
        gotEodReports(state, result) {
            state.eodReports = result;
        },
        isLoading(state, loading) {
            state.loading = loading;
        },
    },
    actions: {
        async getEodReport({ commit }, reportId) {
            commit("isLoading", true);

            const result = await apiGetEodReport.getById(reportId);

            if (result) {
                commit("gotEodReport", result);
            }

            commit("isLoading", false);
        },

        async getEodReports({ commit }, venueId) {
            commit("isLoading", true);

            const result = await apiGetEodReports.getByVenueId(venueId);

            if (result) {
                commit("gotEodReports", result);
            }

            commit("isLoading", false);
        },

        async addNewEodReport({ commit, dispatch }, venueId) {
            console.log("Adding new report: venueId", venueId);
            const result = await apiAddEodReport.post(venueId);

            await dispatch("getEodReports");

            return result;
        },

        async updateEodReport({ commit, dispatch }, eodReport) {
            const result = await apiUpdateEodReport.put(eodReport);

            await dispatch("getEodReports");

            return result;
        },

        async deleteEodReport({ commit, dispatch }, eodReportId) {
            await apiDeleteEodReport.del(eodReportId);

            await dispatch("getEodReports");
        },

        async sendEodReport({ commit }, reportId) {
            commit("isLoading", true);

            await apiSendEodReport.post(reportId);

            commit("isLoading", false);
        },
    },
    getters: {
        eodReports: state => state.eodReports,
        eodReport: state => state.eodReport,
    }
};